import { defineMessages } from 'react-intl';

export const projectTitleClusterMessages = defineMessages({
  loading: {
    defaultMessage: 'Loading',
    id: 'PeuWLgWDwc',
    description: 'Fallback while project title metadata loads',
  },
  renameInputLabel: {
    defaultMessage: 'Rename chat',
    id: 'MsAJwApGxX',
    description: 'Accessible label for the inline project-title rename input',
  },
});
